import React, { useEffect, useState } from "react";
import styled from "styled-components";
import assets from "../../../assets/assets";
import { IconController, MostCardImage } from "../../Scripts/ImgController";
import Skeleton from "react-loading-skeleton";
const Wrapper = styled.div`
  box-shadow: 0px 4px 6px -1px rgba(0, 0, 0, 0.1),
    0px 2px 4px -1px rgba(0, 0, 0, 0.06);
  border-radius: 12px;
  /* height: 100%; */
  position: relative;
  /* height: 347px; */
  .image-holder {
    width: 210px;
    height: 210px;
    position: relative;
  }
  @media (max-width: 767px) {
    .image-holder {
      width: 150px;
      height: 150px;
    }
  }
  .img-border {
    border-bottom: 5px solid;
    border-left: 5px solid;
    border-right: 5px solid;
  }
`;

const MostCards = ({ loaded, which, data, newRequest }) => {
  const [title, setTitle] = useState("");
  const [decor, setDecor] = useState();
  const [description, setDescription] = useState();
  const [border, setBorder] = useState("");
  useEffect(() => {
    if (which === "listen") {
      setTitle("сонсолттой");
      setDecor(assets.svg.listenedDecor);
      setDescription("сонссон");
      setBorder("0061FF");
    }
    if (which === "download") {
      setTitle("таталттай");
      setDecor(assets.svg.downloadedDecor);
      setDescription("татсан");
      setBorder("10B981");
    }
    if (which === "like") {
      setTitle("хандалттай");
      setDecor(assets.svg.likedDecor);
      setDescription("таалагдсан");
      setBorder("EF4444");
    }
  }, []);
  return (
    <Wrapper className="min-w-[220px] md:min-w-[260px] flex-shrink-0 xl:flex-shrink xl:min-w-0 snap-start 2xl:w-1/4 xl:w-1/3">
      <div className="flex flex-col w-full px-4 md:px-8 py-4 md:py-6 items-center">
        {loaded ? (
          <h5 className="text-mmusic text-sm font-bold pb-6">
            Хамгийн их {title}
          </h5>
        ) : (
          <div className="w-full h-full pb-6 text-center">
            <Skeleton count={1} height={20} width="80%" />
          </div>
        )}

        <div className="image-holder">
          <MostCardImage
            src={data?.song?.cover}
            bColor={border}
            newRequest={newRequest}
          />
          <IconController
            className="absolute right-0 bottom-0 z-10"
            src={decor}
            alt=""
          />
        </div>
        {loaded ? (
          <>
            <h5 className="font-semibold text-sm pb-1.5 pt-3 text-center">
              {data?.song?.name}
            </h5>
            <h5 className="text-xs">
              <span className="font-bold">{data?.count}</span>
              &nbsp;
              {description}
            </h5>
          </>
        ) : (
          <div className="w-full h-full text-center pt-0.5">
            <Skeleton count={1} height={16} width="80%" />
            <Skeleton count={1} height={16} width="40%" />
          </div>
        )}
      </div>
    </Wrapper>
  );
};

export default MostCards;
